import script from "./InfoDisplayBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoDisplayBlock.vue?vue&type=script&setup=true&lang=js"

import "./InfoDisplayBlock.vue?vue&type=style&index=0&id=67c433c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67c433c9"]])

export default __exports__